module.exports = __webpack_public_path__ + "img/step45_b_printer_basic_fix_screws.87694af3.png";